import React from 'react';
import { Link } from 'react-router-dom';
import { Wordmark } from '../brand/Wordmark';
import { footerGroups } from '../../data/navigation';
import { useLanguage } from '../../contexts/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="border-t mf-hairline bg-[#050F1C]" data-id="element-439" data-mp="5n2onnfs2o94">
      <div className="mx-auto max-w-site px-5 pb-6 pt-10 md:px-8 md:pt-12" data-id="element-440" data-mp="5mkju2f1v1pl">
        <div className="grid grid-cols-2 gap-x-6 gap-y-8 lg:grid-cols-[1.3fr_repeat(4,1fr)] lg:gap-10" data-id="element-441" data-mp="p16r5u38uz8">
          <div className="col-span-2 lg:col-span-1" data-id="element-442" data-mp="3s1m1hfp3tvdh">
            <Wordmark data-id="element-443" data-mp="3n3kb09pcmtrz" />
            <p className="mt-4 max-w-xs font-display text-lg uppercase tracking-[0.06em] text-titanium" data-id="element-444" data-mp="3n32d78n1g7hy">
              Professional-Grade Lighting. Built for the Elements.
            </p>
            <p className="mt-3 text-sm text-titanium/70" data-id="element-445" data-mp="3e2mcg6xojegs">{t('footer.tagline')}</p>
          </div>
          {footerGroups.map(g => <nav key={g.title} aria-label={g.title} data-id="element-446" data-mp="39541yc40kr6o">
              <h2 className="font-display text-sm font-semibold uppercase tracking-[0.14em] text-white" data-id="element-447" data-mp="2kdd10pdv6tp3">{g.title}</h2>
              <ul className="mt-3 space-y-2" data-id="element-448" data-mp="2p4ctnifyapls">
                {g.links.map(l => <li key={l.to} data-id="element-449" data-mp="2bcomltkk6rbo">
                    <Link to={l.to} className="text-sm text-titanium transition-colors duration-150 hover:text-white" data-id="element-450" data-mp="2bdpwvvtr39sc">
                      {l.label}
                    </Link>
                  </li>)}
              </ul>
            </nav>)}
        </div>
        <div className="mt-8 border-t mf-hairline pt-5 text-xs text-titanium/60" data-id="element-451" data-mp="382yy97aoeyug">
          <p data-id="element-452" data-mp="2u369vimmgupn">© {new Date().getFullYear()} MarineForceLED. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}